

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class Footer extends Vue {
  get isSplash() {
    return this.$route.name === 'login';

  }
}

